import React from 'react';
import { MobileApp } from '../components/MobileApp/MobileApp';
import { DesktopApp } from '../components/DesktopApp/DesktopApp';
import './App.scss';

export const App = ({ mobile }: { mobile: boolean }) => (mobile ? <MobileApp /> : <DesktopApp />);
